<template>
  <div class="item-container">
    <div class="cover">
      <img src="../assets/cover.png">
      <i :class="[isCurrent && playing ? 'btn-pause': 'btn-play', progressHover && 'btn-play-hover']" @click="onPlaySong"/>
    </div>
    <div class="info">
      <div class="name">
        <span @click="$emit('goSong')">{{song.wksongname}}</span>
        <span v-if="isMy && song.wkckstatus !== 2 " @click="$emit('edit')" class="edit"><i />编辑</span>
        <span v-if="isMy && song.wkckstatus === 2 && song.wkprivacy === 1" @click="$emit('open')" class="lock"><i /></span>
      </div>
      <div class="info-one">
        <span @click="!isMy && $router.push({name:'phome', params: {key: $store.state.songInfo.curIndex}})">上传者：{{song.userfullname}}</span>
        <span>校区：{{song.convert.userschool}}</span>
      </div>
      <div class="info-two">
        <span>歌手：{{song.wksinger}}</span>
        <span>作词：{{song.wkwriter}}</span>
        <span>作曲：{{song.wkcompositor}}</span>
        <span>编曲：{{song.wkmelody}}</span>
      </div>
      <div class="progress" @mouseenter="progressHover = true" @mouseleave="progressHover = false">
        <Progress  :playProgress="progress" @dragend="onProgress"/>
        <div v-if="song.wksongduration" class="time time-current">{{secondToTime(song.wksongduration * progress)}}</div>
        <div v-if="song.wksongduration" class="time time-total">{{secondToTime(song.wksongduration)}}</div>
      </div>
      <div class="info-three">
        <div v-if="isMy && song.wkckstatus !== 2" :class="['state', song.wkckstatus === 1 ? 'ing' : 'err']">
          <span>●</span>{{song.convert.wkckstatus}}
        </div>
        <div class="heat"> <i class="fire"/><i class="fire"/>  {{song.hot}}</div>
        <div class="date">{{parseTime(song.wkaddtime)}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Progress from './audioPlayer/PlayerControllerProgress.vue'
import { relativelyTime, secondToTime } from '../utils.js'
// import cover from '../assets/cover.svg'
export default {
  components:{
    Progress
  },
  data() {
    return {
      progressHover: false,
      secondToTime,
    }
  },
  props: {
    song: {
      type: Object,
      required: true,
    },
    isMy: {
      type: Boolean,
      default: false,
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
    playing: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    onPlaySong () {
      this.$emit('play')
    },
    parseTime (time) {
      return relativelyTime(time)
    },
    onProgress (percentage) {
      this.$emit('progress', percentage)
    }
  },
  created: function () {
  }
}
</script>
<style lang="less" scoped>
  .item-container {
    position: relative;
    display: flex;
    padding-bottom: 40px;
    width: 100%;
    border-bottom: 1px solid #E1E1E1;
    font-weight: normal;
    .cover {
      position: relative;
      width: 160px;
      height: 160px;
      img {
        width: 100%;
        height: 100%;
      }
      i {
        display: block;
        position: absolute;
        width:152px;
        height: 160px;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        cursor: pointer;
        &.btn-play-hover {
          background: url('../assets/icons/play.png') center/58px no-repeat;
        }
        &.btn-play:hover {
          background: url('../assets/icons/play.png') center/58px no-repeat;
        }
        &.btn-pause {
          background: url('../assets/icons/pause.png') center/58px no-repeat;
        }
      }
    }
    .info {
      flex: 1;
      margin-left: 16px;
      color:  #B3B3B3;
      font-size: 12px;
      text-align: left;
      .name {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        span {
          &:hover {
            color: #40D77E;
          }
          cursor: pointer;
          img {
            height: 100%;
          }
          &:first-child {
            font-weight: bold;
          }
        }
        i {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
        .edit {
          margin-left: 16px;
          height:20px;
          padding: 2px 6px 4px 4px;
          color: #40D77E;
          background: rgba(64,215,126,0.10);
          border-radius: 10px;
          i {
              background: url("../assets/icons/edit-hover.png") center center/cover no-repeat;
          }
        }

        .lock {
          margin-left: 4px;
          i {
              background: url("../assets/icons/lock.png") center center/cover no-repeat;
          }
        }
      }
      .info-one {
        margin-top: 6px;
        color: #333333;
        span{
          display: inline-block;
          width:180px;
          margin-right: 4px;
          line-height: 17px;
          &:nth-child(1):hover {
            color: #40D77E;
            cursor: pointer;
          }
        }
      }
      .info-two {
        margin-top: 14px;
        span {
          display: inline-block;
          width:180px;
          margin-right: 4px;
          line-height: 17px;
        }
      }
      .progress {
        position: relative;
        margin-top: 22px;
        width: 100%;
        height: 60px;
        .time {
          position: absolute;
          width: 36px;
          height: 12px;
          font-size: 10px;
          line-height: 12px;
          font-weight: normal;
          text-align: center;
          color: #40D77E;
          background: #181818;
        }
        .time-current {
          top: 31px;
          left: 0;
        }
        .time-total {
          top: 31px;
          right: 0;
        }
        .player-bar-wrap {
          margin: 5px 0;
          height: 100%;
          /deep/.player-bar {
            height: 100%;
            background: url("../assets/icons/progress.png") left/contain ;
          }
          /deep/.player-played {
              height: 100%;
              background: url("../assets/icons/progress-played.png") left/auto 100% ;
              
          }
          /deep/ .player-thumb {
                display: none;
          }
        }
      }
      .info-three {
        position: absolute;
        top: 0;
        right: 0;
        text-align: right;
        .state, .heat {
          font-size: 14px;
          color: #333333;
          line-height: 22px;
          i {
            display: inline-block;
            height: 100%;
            vertical-align: text-bottom;
          }
        }
        .heat {
          .fire {
            display: inline-block;
            width: 12px;
            height: 12px;
            line-height: 20px;
            vertical-align: baseline;
            background: url("../assets/icons/fire.png") center center/contain no-repeat;
          }
        }
        .state {
          span {
            margin-right: 8px;
            font-weight: bold;
            color: red;
          }
        }
        .state.ing {
          span {
            color: #40D77E;
          }
        }
        .date {
          margin-top: 6px;
          line-height: 17px;
        }
      }
    }
  }
</style>


